import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MdCloudUpload, MdDelete, MdBusiness } from 'react-icons/md';
import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytesResumable,
} from 'firebase/storage';
import { storage } from '../firebase.config';
import Loader from './Loader';
import { updateService, getServiceById } from '../utils/firebaseFunctions';
import Sidebar from './Sidebar';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import { BiDetail, BiImage } from 'react-icons/bi';
import ReactQuill from 'react-quill';

const EditService = () => {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
    const [bannercontent, setBannerContent] = useState("");
  const [description, setDescription] = useState('');
  const [field, setField] = useState(false);
  const [alertStatus, setAlertStatus] = useState('danger');
  const [msg, setMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [imageAssest, setImageAssest] = useState(null);
   const [isLoadingBanner, setIsLoadingBanner] = useState(false);
    const [BannerimageAssest, setBannerImageAssest] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = (state) => {
    setIsSidebarOpen(state);
  };

  useEffect(() => {
    const fetchServiceData = async () => {
      setIsLoading(true);
      try {
        const serviceData = await getServiceById(serviceId);
        if (serviceData) {
          setTitle(serviceData.title);
          setDescription(serviceData.description);
          setImageAssest(serviceData.imageurl);
          setBannerContent(serviceData.bannercontent);
          setBannerImageAssest(serviceData.bannerimageurl)
          setIsLoading(false);
        } else {
          toast.error('Service not found.');
          navigate('/Addservices');
        }
      } catch (error) {
        console.error('Error fetching service data:', error);
        toast.error('Failed to fetch service data. Please try again.');
        setIsLoading(false);
      }
    };

    fetchServiceData();
  }, [serviceId, navigate]);

  const uploadImage = (e) => {
    setIsLoading(true);
    const imageFile = e.target.files[0];
    const storageRef = ref(storage, `Images/<span class="math-inline">\{Date\.now\(\)\}\-</span>{imageFile.name}`);
    const uploadTask = uploadBytesResumable(storageRef, imageFile);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const uploadProgress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is ${uploadProgress}% done`);
      },
      (error) => {
        console.error(error);
        setField(true);
        setMsg('Error while uploading: Try again');
        setAlertStatus('danger');
        setTimeout(() => {
          setField(false);
          setIsLoading(false);
        }, 4000);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log('File available at', downloadURL);
          setImageAssest(downloadURL);
          setIsLoading(false);
          setField(true);
          setMsg('Image uploaded successfully');
          setAlertStatus('success');
          setTimeout(() => {
            setField(false);
          }, 4000);
        });
      }
    );
  };

  const deleteImage = () => {
    if (!imageAssest) {
      setField(true);
      setMsg('No image to delete');
      setAlertStatus('warning');
      setTimeout(() => {
        setField(false);
      }, 4000);
      return;
    }

    setIsLoading(true);
    const deleteRef = ref(storage, imageAssest);

    deleteObject(deleteRef)
      .then(() => {
        setImageAssest(null);
        setIsLoading(false);
        setField(true);
        setMsg('Image deleted successfully');
        toast.success('Image deleted successfully!');
        setAlertStatus('success');
        setTimeout(() => {
          setField(false);
        }, 4000);
      })
      .catch((error) => {
        console.error('Error deleting image:', error);
        setIsLoading(false);
        setField(true);
        setMsg('Error while deleting: Try again');
        setAlertStatus('danger');
        setTimeout(() => {
          setField(false);
        }, 4000);
      });
  };
  const uploadBannerImage = (e) => {
    setIsLoadingBanner(true);
    const imageFile = e.target.files[0];
    const storageRef = ref(storage, `Images/${Date.now()}-${imageFile.name}`);
    const uploadTask = uploadBytesResumable(storageRef, imageFile);
  
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const uploadProgress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is ${uploadProgress}% done`);
      },
      (error) => {
        console.error(error);
        setField(true);
        setMsg('Error while uploading: Try again');
        setAlertStatus('danger');
        setTimeout(() => {
          setField(false);
          setIsLoadingBanner(false);
        }, 4000);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log('File available at', downloadURL);
          // Correctly update the state after the download URL is retrieved.
          setBannerImageAssest(downloadURL);
          setIsLoadingBanner(false);
          setField(true);
          setMsg('Image uploaded successfully');
          setAlertStatus('success');
          setTimeout(() => {
            setField(false);
          }, 4000);
        });
      }
    );
  };
  const deleteBannerImage = () => {
    if (!BannerimageAssest) {
      setField(true);
      setMsg('No image to delete');
      setAlertStatus('warning');
      setTimeout(() => {
        setField(false);
      }, 4000);
      return;
    }

    setIsLoadingBanner(true);
    const deleteRef = ref(storage, BannerimageAssest);

    deleteObject(deleteRef)
      .then(() => {
        setBannerImageAssest(null);
        setIsLoadingBanner(false);
        setField(true);
        setMsg('Image deleted successfully');
        toast.success('Image deleted successfully!');
        setAlertStatus('success');
        setTimeout(() => {
          setField(false);
        }, 4000);
      })
      .catch((error) => {
        console.error('Error deleting image:', error);
        setIsLoadingBanner(false);
        setField(true);
        setMsg('Error while deleting: Try again');
        setAlertStatus('danger');
        setTimeout(() => {
          setField(false);
        }, 4000);
      });
  };

  const updateDetails = async () => {
    setIsLoading(true);
    try {
      if (!title || !description || !imageAssest || !bannercontent || !BannerimageAssest) {
        setField(true);
        setMsg("Required fields can't be empty");
        setAlertStatus('danger');
        setTimeout(() => {
          setField(false);
          setIsLoading(false);
        }, 4000);
        return;
      }

      const data = {
        id: serviceId,
        title: title,
        description: description,
        imageurl: imageAssest || "",
        bannercontent :bannercontent || "",
          bannerimageurl :BannerimageAssest || "",
      };

      await updateService(data);
      toast.success('Service updated successfully!');
      setIsLoading(false);
      setField(true);
      setMsg('Service updated successfully');
      setTimeout(() => {
        setField(false);
        navigate('/Addservices');
      }, 3000);
    } catch (error) {
      console.error(error);
      setField(true);
      setMsg('Error while updating: Try again');
      setAlertStatus('danger');
      setTimeout(() => {
        setField(false);
        setIsLoading(false);
      }, 4000);
    }
  };
  return (
    <div className="flex h-2000 overflow-hidden lg:mt-20 mt-0">
        <Helmet>
            <title>Edit Service - Admin Panel</title>
            <meta name="description" content="Edit and manage services companies efficiently." />
        </Helmet>

        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

        <div
            className={`flex-1 overflow-y-auto transition-all duration-300 lg:mt-2 mt-10 
      ${isSidebarOpen ? 'ml-56 p-2 mr-[-16px] ' : 'lg:ml-20 sm:ml-2 lg:p-8 sm:p-6'}`}
        >
            <div className="w-full max-w-3xl mx-auto p-4">
                <h1 className="lg:text-2xl text-md font-bold mb-4">Edit Service</h1>

                <div className="space-y-4 border-gray-300 rounded-lg">
                    {field && (
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            className={`w-full p-2 rounded-lg text-center text-lg font-semibold ${alertStatus === 'danger'
                                ? 'bg-red-400 text-red-800'
                                : alertStatus === 'success'
                                    ? 'bg-green-400 text-green-800'
                                    : 'bg-yellow-400 text-yellow-800'
                                }`}
                        >
                            {msg}
                        </motion.p>
                    )}

                    <div className="flex items-center border-b border-gray-300 py-2">
                        <MdBusiness className="text-xl text-gray-700" />
                        <input
                            type="text"
                            className="w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900 pl-3"
                            required
                            value={title}
                            placeholder="Enter Title"
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </div>

                    <div className="border-b border-gray-300 py-2 mb-8">
                        <label
                            className="text-gray-700 flex items-center space-x-2"
                            htmlFor="description"
                        >
                            <BiDetail className="text-xl text-gray-700" />
                            <span className="lg:text-[15px] text-[13px]">Description</span>
                        </label>

                        <ReactQuill
                            id="jobDescription"
                            value={description}
                            onChange={setDescription}
                            placeholder="Enter Job Description"
                            className="h-48 md:h-64 lg:h-72 mb-10 lg:text-[15px] text-[13px]"
                            modules={{
                                toolbar: [
                                    [{ header: "1" }, { header: "2" }, { font: [] }],
                                    ["bold", "italic", "underline"],
                                    ["link", "image"],
                                    [{ list: "ordered" }, { list: "bullet" }],
                                    ["clean"],
                                ],
                            }}
                        />
                    </div>

                    <label
                        className="text-gray-700 flex items-center space-x-2"
                        htmlFor="description"
                    >
                        <BiImage className="text-xl text-gray-700" />
                        <span className="lg:text-[15px] text-[13px]">Image Upload</span>
                    </label>

                    <div className="relative flex justify-center items-center border-2 border-dotted border-gray-300 w-full h-56 rounded-lg overflow-hidden cursor-pointer">
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                {!imageAssest ? (
                                    <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                                        <MdCloudUpload className="text-gray-500 text-3xl hover:text-gray-700" />
                                        <p className="text-gray-500 hover:text-gray-700 lg:text-[15px] text-[13px]">
                                            Click here to upload service Image
                                        </p>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={uploadImage}
                                            className="w-0 h-0"
                                        />
                                    </label>
                                ) : (
                                    <div className="relative w-100 h-40">
                                        <img
                                            src={imageAssest}
                                            alt="uploaded"
                                            className="w-full h-full object-cover rounded-lg"
                                        />
                                        <button
                                            className="absolute top-3 right-3 p-2 rounded-full bg-red-500 text-white text-xl hover:bg-red-600"
                                            onClick={deleteImage}
                                        >
                                            <MdDelete />
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
 <div className="flex items-center border-b border-gray-300 py-2">
              <MdBusiness className="text-xl text-gray-700" />
              <input
                type="text"
                className="w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900 pl-3"
                required
                value={bannercontent}
                placeholder="Enter Banner Content"
                onChange={(e) => setBannerContent(e.target.value)}
              />
            </div>
            <label
                        className="text-gray-700 flex items-center space-x-2"
                        htmlFor="description"
                    >
                        <BiImage className="text-xl text-gray-700" />
                        <span className="lg:text-[15px] text-[13px]">Banner Image Upload</span>
                    </label>

                    <div className="relative flex justify-center items-center border-2 border-dotted border-gray-300 w-full h-56 rounded-lg overflow-hidden cursor-pointer">
                        {isLoadingBanner ? (
                            <Loader />
                        ) : (
                            <>
                                {!BannerimageAssest ? (
                                    <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                                        <MdCloudUpload className="text-gray-500 text-3xl hover:text-gray-700" />
                                        <p className="text-gray-500 hover:text-gray-700 lg:text-[15px] text-[13px]">
                                            Click here to upload service Image
                                        </p>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={uploadBannerImage}
                                            className="w-0 h-0"
                                        />
                                    </label>
                                ) : (
                                    <div className="relative w-100 h-40">
                                        <img
                                            src={BannerimageAssest}
                                            alt="uploaded"
                                            className="w-full h-full object-cover rounded-lg"
                                        />
                                        <button
                                            className="absolute top-3 right-3 p-2 rounded-full bg-red-500 text-white text-xl hover:bg-red-600"
                                            onClick={deleteBannerImage}
                                        >
                                            <MdDelete />
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div className="flex items-center">
                        <button
                            type="button"
                            className="relative inline-block border border-[#005eb8] text-[#005eb8] lg:text-[15px] text-[13px] font-[500] leading-[1.5] px-[30px] py-[10px]  transition-all duration-200 hover:bg-[#005eb8] hover:text-white"
                            onClick={updateDetails}
                        >
                            Update
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
};

export default EditService;